import React, { useEffect, useState } from 'react'

import { IQuestionnaire } from '../../../types/questionnaire';
import useGetQuestionnaire from '../../../hooks/user/useGetQuestionnaire';

import DataTable from '../../reusables/DataTable';
import { ColDef } from '@ag-grid-community/core';

interface IQuestionnaireProps {
    applicantId: number;
}

const Questionnaire = ({ applicantId }: IQuestionnaireProps) => {

    const [question, setQuestion] = useState<IQuestionnaire[]>([]);
    const { data: questionData, isPending, isError } = useGetQuestionnaire(applicantId);

    useEffect(() => {
        setQuestion(questionData ? questionData : []);
    }, [questionData]); //eslint-disable-line

    const questionnaireColumns: ColDef[] = [
        { width: 700, field: "questionCode", headerName: "Question", valueGetter: ({ data }) => data?.question_codeI?.description },
        { field: "answer", headerName: "Answer", filter: false, sort: null },
        { field: "repeat", headerName: "Repeat", filter: false, sort: null, valueGetter: ({ data }) => data?.question_codeI?.repeat },
    ];

    if (isPending) return <div className="imm_consultant__loading"><div className="imm_consultant__process_loader" />Loading...</div>
    if (isError) return <div className="imm_consultant__loading">Questionnaire Not found</div>

    return (
        <div className='imm_questionnaire__main'>
            <div className="imm_questionnaire__content"><DataTable data={question} columns={questionnaireColumns} paginationPageSize={200} /></div>
        </div>
    );
}
export default Questionnaire;